// API Endpoints for Notification Banner Manager
export const ENDPOINTS = {
    JourneyDetails: 'journey-details',
    siteNotifications: 'site-notifications',
    siteSaveNotifications: 'save-site-notification'
};
